import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import { DISMISSAL_TYPE_SESSION, DISMISSAL_TYPE_LOCAL_STORAGE, DISMISSAL_TYPE_DISABLED } from './TimedElement.constants';
import { TimedElementProvider } from './TimedElement.context';
import { getStorageMechanism, getTimedElementStorageKey } from './TimedElement.utils';
import ActionComponent from './components/ActionComponent/ActionComponent';
import Element from './components/Element/Element';
import useStorage from '../../../../hooks/use-storage';
import { ChildrenPropType } from '../../../../services/proptypes';
import DateUtils from '../../../../utils/date/DateUtils';
var defaultProps = {
  delay: null,
  startTime: null,
  endTime: null,
  timezone: 'UTC',
  duration: null,
  dismissalType: DISMISSAL_TYPE_SESSION,
  children: null
};
export default function TimedElement(_ref) {
  var delay = _ref.delay,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    timezone = _ref.timezone,
    duration = _ref.duration,
    dismissalType = _ref.dismissalType,
    referenceId = _ref.referenceId,
    children = _ref.children;
  var storageMechanism = getStorageMechanism(dismissalType);
  var _useState = useState(_isNil(delay)),
    _useState2 = _slicedToArray(_useState, 2),
    delayTimePassed = _useState2[0],
    setDelayTimePassed = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    durationTimePassed = _useState4[0],
    setDurationTimePassed = _useState4[1];
  var _useStorage = useStorage(getTimedElementStorageKey(referenceId), false, {
      storageMechanism: storageMechanism
    }),
    _useStorage2 = _slicedToArray(_useStorage, 3),
    alreadyShown = _useStorage2[0],
    setAlreadyShown = _useStorage2[1],
    storageLoaded = _useStorage2[2];
  function markAsShown() {
    setAlreadyShown(true);
  }
  function setDelayAndFireDuration() {
    setDelayTimePassed(true);
    if (duration) {
      setTimeout(function () {
        return setDurationTimePassed(true);
      }, duration);
    }
  }
  function forceShow() {
    setAlreadyShown(false);
    setDelayTimePassed(true);
    setDurationTimePassed(false);
  }
  useEffect(function () {
    var modalTimeout;
    var isValidDelay = _isNumber(delay) && delay >= 0;
    var shouldDelayDisplay = isValidDelay && !alreadyShown && storageLoaded;
    if (shouldDelayDisplay) {
      modalTimeout = setTimeout(setDelayAndFireDuration, delay || 0);
    }
    return function () {
      clearTimeout(modalTimeout);
    };
  }, [storageLoaded]);
  useEffect(function () {
    if (delayTimePassed) {
      return markAsShown;
    }
    return function () {
      return null;
    };
  }, [delayTimePassed]);
  var isDismissalTypeDisabled = dismissalType === DISMISSAL_TYPE_DISABLED;
  var alreadyShownFromStorage = isDismissalTypeDisabled ? false : alreadyShown;
  var context = {
    setShownInSession: markAsShown,
    forceShow: forceShow,
    shouldShow: delayTimePassed && !durationTimePassed && !alreadyShownFromStorage && storageLoaded
  };
  var isOneDateTimeDefined = !_isEmpty(startTime) || !_isEmpty(endTime);
  var isBetweenDates = DateUtils.isNowBetweenDates(startTime, endTime, timezone);
  var content = /*#__PURE__*/React.createElement(TimedElementProvider, {
    value: context
  }, children);
  if (isOneDateTimeDefined && !isBetweenDates) {
    content = null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "timed-element"
  }, content);
}
TimedElement.defaultProps = defaultProps;
TimedElement.Element = Element;
TimedElement.ActionComponent = ActionComponent;